var _path, _path2, _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3C13.3 3 12 4.66667 11.5 5.5V18C10.6667 19 9 21.5 9 23.5C9 26 11 28.5 15 28.5C19 28.5 20.5 25 20.5 23C20.5 21.4 19.1667 18.6667 18.5 17.5V5C17.6667 4.33333 15.7 3 14.5 3Z",
    fill: "#3952BF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C10 5.67392 10.5268 4.40215 11.4645 3.46447C12.4022 2.52678 13.6739 2 15 2C16.3261 2 17.5979 2.52678 18.5355 3.46447C19.4732 4.40215 20 5.67392 20 7V17.9C20.9647 18.8846 21.6172 20.132 21.8758 21.4859C22.1343 22.8399 21.9874 24.24 21.4534 25.5107C20.9194 26.7815 20.0222 27.8663 18.8741 28.6292C17.7261 29.392 16.3784 29.799 15 29.799C13.6216 29.799 12.2739 29.392 11.1259 28.6292C9.97784 27.8663 9.08058 26.7815 8.5466 25.5107C8.01262 24.24 7.8657 22.8399 8.12426 21.4859C8.38281 20.132 9.03533 18.8846 10 17.9V7ZM15 4C14.2044 4 13.4413 4.31607 12.8787 4.87868C12.3161 5.44129 12 6.20435 12 7V18.774L11.668 19.074C10.9131 19.749 10.3811 20.6374 10.1421 21.6215C9.90323 22.6055 9.96876 23.639 10.3301 24.585C10.6914 25.531 11.3314 26.345 12.1655 26.9193C12.9995 27.4936 13.9883 27.8011 15.001 27.8011C16.0137 27.8011 17.0025 27.4936 17.8365 26.9193C18.6706 26.345 19.3106 25.531 19.6719 24.585C20.0332 23.639 20.0988 22.6055 19.8599 21.6215C19.6209 20.6374 19.0889 19.749 18.334 19.074L18 18.772V7C18 6.20435 17.6839 5.44129 17.1213 4.87868C16.5587 4.31607 15.7957 4 15 4Z",
    fill: "#3952BF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#3952BF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 23,
    r: 3,
    fill: "#3952BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.d2ba0585201c761d9d26d4d575c59b35.svg";
export { ForwardRef as ReactComponent };